import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ion-padding bg-brand-black text-white text-center py-10" }
const _hoisted_2 = {
  key: 0,
  class: "text-red-400 text-sm mt-4"
}

import {ref} from 'vue';
import {IonButton, modalController} from '@ionic/vue';
import ApiService from '@/services/api/apiService';
import {Observable, ObservableEvent} from '@/services/observable/Observable';


export default /*@__PURE__*/_defineComponent({
  __name: 'SleepModeSheet',
  setup(__props) {

const busy = ref(false);
const error = ref('');

const wake = async () => {
  busy.value = true;
  error.value = '';
  try {
    await ApiService.User().wake();
    Observable.emit(ObservableEvent.UserChanged);
    await modalController.dismiss();
  } catch (e: any) {
    error.value = e?.message || 'Could not wake account';
  } finally {
    busy.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-xl font-semibold mb-2" }, "Account sleeping", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm text-brand-light-gray mb-6" }, " Your account is in sleep mode. Wake it to continue using Pineapple. ", -1)),
    _createVNode(_unref(IonButton), {
      expand: "block",
      color: "primary",
      disabled: busy.value,
      onClick: wake
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(busy.value ? 'Waking…' : 'Wake account'), 1)
      ]),
      _: 1
    }, 8, ["disabled"]),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})